<template>
  <div>
    <Table :columns="columns" :data="resources" size="small" highlight-row stripe max-height="700" border>
      <template slot-scope="{ row }" slot="opening_usd_balance">
        <div>
          <ts-display-currency :amount="row.opening_usd_balance ? row.opening_usd_balance : 0" :currency_id="1" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="closing_usd_balance">
        <div>
          <ts-display-currency :amount="row.closing_usd_balance ? row.closing_usd_balance : 0" :currency_id="1" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="opening_khr_balance">
        <div>
          <ts-display-currency :amount="row.opening_khr_balance ? row.opening_khr_balance : 0" :currency_id="2" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="closing_khr_balance">
        <div>
          <ts-display-currency :amount="row.closing_khr_balance ? row.closing_khr_balance : 0" :currency_id="2" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="cash_usd_in">
        <div>
          <ts-display-currency :amount="row.cash_usd_in ? row.cash_usd_in : 0" :currency_id="1" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="cash_usd_out">
        <div>
          <ts-display-currency :amount="row.cash_usd_out ? row.cash_usd_out : 0" :currency_id="1" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="cash_khr_in">
        <div>
          <ts-display-currency :amount="row.cash_khr_in ? row.cash_khr_in : 0" :currency_id="2" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="cash_khr_out">
        <div>
          <ts-display-currency :amount="row.cash_khr_out ? row.cash_khr_out : 0" :currency_id="2" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="opening_member_card">
        <div>
          <b class="ts-text-blue-700">
            {{ row.opening_member_card ? row.opening_member_card : 0 }}
          </b>
        </div>
      </template>
      <template slot-scope="{ row }" slot="closing_member_card">
        <div>
          <b class="ts-text-blue-700">
            {{ row.closing_member_card ? row.closing_member_card : 0 }}
          </b>
        </div>
      </template>
      <template slot-scope="{ row }" slot="member_card_in">
        <div>
          <b class="ts-text-blue-700">
            {{ row.member_card_in ? row.member_card_in : 0 }}
          </b>
        </div>
      </template>
      <template slot-scope="{ row }" slot="member_card_out">
        <div>
          <b class="ts-text-blue-700">
            {{ row.member_card_out ? row.member_card_out : 0 }}
          </b>
        </div>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  name: 'tableExpand',
  props: {
    row: Object
  },
  data() {
    return {}
  },
  computed: {
    resources() {
      return this.row.details
    },
    columns() {
      return [
        {
          title: this.$t('floatingCashier.floatingDate'),
          key: 'floating_detail_date',
          width: 170
        },
        {
          title: this.$t('floatingCashier.cashier'),
          key: 'cashier_name',
          width: 140
        },
        {
          title: this.$t('floatingCashier.khr'),
          align: 'center',
          children: [
            {
              title: this.$t('floatingCashier.opening'),
              slot: 'opening_khr_balance',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.closing'),
              slot: 'closing_khr_balance',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.in'),
              slot: 'cash_khr_in',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.out'),
              slot: 'cash_khr_out',
              align: 'center',
              minWidth: 130
            },
          ]
        },
        {
          title: this.$t('floatingCashier.usd'),
          align: 'center',
          children: [
            {
              title: this.$t('floatingCashier.opening'),
              slot: 'opening_usd_balance',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.closing'),
              slot: 'closing_usd_balance',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.in'),
              slot: 'cash_usd_in',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.out'),
              slot: 'cash_usd_out',
              align: 'center',
              minWidth: 130
            },
          ]
        },
        {
          title: this.$t('floatingCashier.memberShipCard'),
          align: 'center',
          children: [
            {
              title: this.$t('floatingCashier.opening'),
              slot: 'opening_member_card',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.closing'),
              slot: 'closing_member_card',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.in'),
              slot: 'member_card_in',
              align: 'center',
              minWidth: 130
            },
            {
              title: this.$t('floatingCashier.out'),
              slot: 'member_card_out',
              align: 'center',
              minWidth: 130
            },
          ]
        },
        {
          title: this.$t('floatingCashier.remark'),
          key: 'remark',
          width: 180,
        },
        {
          title: this.$t('floatingCashier.createdBy'),
          key: 'created_by_name',
          width: 130,
        },
        {
          title: this.$t('floatingCashier.createdDate'),
          key: 'created_date',
          minWidth: 180,
        },
      ]
    }
  },
  methods: {}
}
</script>
